import React from 'react';
import { SectionCard } from '../common/SectionCard';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/Table';
import { daysUntil } from '../../utils/format';
import type { ApplicationRecord } from '../../types/domain';
export function OfficerWorkload({
  records
}: {
  records: ApplicationRecord[];
}) {
  const officers = Array.from(new Set(records.map(record => record.officer)));
  const rows = officers.map(officer => {
    const assigned = records.filter(record => record.officer === officer);
    return {
      officer,
      assigned: assigned.length,
      dueSoon: assigned.filter(record => {
        const days = daysUntil(record.slaDueOn);
        return days >= 0 && days <= 14;
      }).length,
      overdue: assigned.filter(record => daysUntil(record.slaDueOn) < 0).length,
      meanDays: Math.round(assigned.reduce((sum, record) => sum + record.daysInStage, 0) / Math.max(assigned.length, 1))
    };
  }).sort((a, b) => b.assigned - a.assigned);
  const max = Math.max(...rows.map(row => row.assigned), 1);
  return <SectionCard title="Officer workload" description="Assigned records and SLA exposure per officer" bodyClassName="p-0" data-id="element-620" data-mp="2f55gzbki40o9">
      <div className="overflow-x-auto" data-id="element-621" data-mp="262mit4rnuc8c">
        <Table data-id="element-622" data-mp="263o37zukgb2q">
          <TableHeader data-id="element-623" data-mp="2658r56mdkvrm">
            <TableRow data-id="element-624" data-mp="2tsyzp54vvjb2">
              <TableHead className="min-w-[160px]" data-id="element-625" data-mp="2tsgx7qrmo8up">Officer</TableHead>
              <TableHead className="min-w-[120px]" data-id="element-626" data-mp="2yrtoqotg243m">Assigned</TableHead>
              <TableHead className="text-right" data-id="element-627" data-mp="2ytwfjb2f819e">Due ≤14d</TableHead>
              <TableHead className="text-right" data-id="element-628" data-mp="2k24c9xfwido1">Overdue</TableHead>
              <TableHead className="text-right" data-id="element-629" data-mp="2p1qmdy0fndsm">Mean days</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody data-id="element-630" data-mp="3crb8gprvur64">
            {rows.map(row => <TableRow key={row.officer} data-id="element-631" data-mp="3cprtd2hyqm5x">
                <TableCell className="text-[13px]" data-id="element-632" data-mp="3hikvdim1rgeb">{row.officer}</TableCell>
                <TableCell data-id="element-633" data-mp="3re1jiivery4w">
                  <div className="flex items-center gap-2" data-id="element-634" data-mp="3rd8ogf5tax2l">
                    <div className="h-1.5 w-16 overflow-hidden rounded-sm bg-muted" data-id="element-635" data-mp="3mf729ld3ahmw">
                      <div className="h-full bg-uae-green" style={{
                    width: `${row.assigned / max * 100}%`
                  }} data-id="element-636" data-mp="3mddwe8aaw1fy" />
                    </div>
                    <span className="font-mono text-[12px]" data-id="element-637" data-mp="38ffif3zw670z">{row.assigned}</span>
                  </div>
                </TableCell>
                <TableCell className="text-right font-mono text-[12px] text-uae-bronze" data-id="element-638" data-mp="33oflhyqrvoyh">
                  {row.dueSoon}
                </TableCell>
                <TableCell className={`text-right font-mono text-[12px] ${row.overdue > 0 ? 'text-uae-red' : 'text-muted-foreground'}`} data-id="element-639" data-mp="2ynjlvxdgeoyv">
                  {row.overdue}
                </TableCell>
                <TableCell className="text-right font-mono text-[12px]" data-id="element-640" data-mp="2kr61afdmi7g6">{row.meanDays}</TableCell>
              </TableRow>)}
          </TableBody>
        </Table>
      </div>
    </SectionCard>;
}